module.exports = __webpack_public_path__ + "img/bgDrawer.5064041a.webp";